import { useNavigate } from "react-router-dom";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

export function groupByZone(workshops) {
  const groups = {};
  (workshops || []).forEach((w) => { (groups[w.zone || "Unzoned"] ||= []).push(w); });
  return Object.entries(groups).sort(([a], [b]) => (a === "Unzoned") - (b === "Unzoned") || a.localeCompare(b));
}

export function WorkshopPicker({ workshops, value, allLabel = "All workshops", onChange, navigateTo = true, className = "w-[230px]", testId = "svc-workshop-picker" }) {
  const navigate = useNavigate();
  const groups = groupByZone(workshops);
  const showGroups = groups.length > 1;
  const handle = (v) => {
    if (onChange) onChange(v === "ALL" ? "" : v);
    if (navigateTo) navigate(v === "ALL" ? "/service" : `/service/workshop/${v}`);
  };
  return (
    <Select value={value || "ALL"} onValueChange={handle}>
      <SelectTrigger className={`h-8 ${className} text-xs`} data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        {allLabel && <SelectItem value="ALL">{allLabel}</SelectItem>}
        {groups.map(([zone, list]) => (
          <SelectGroup key={zone}>
            {showGroups && <SelectLabel className="text-[10px] uppercase tracking-wider text-muted-foreground">{zone}</SelectLabel>}
            {list.map((w) => <SelectItem key={w.code} value={w.code} data-testid={`svc-picker-${w.code}`}>{w.code} · {w.name}</SelectItem>)}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
